import React from 'react';
import { Box, CircularProgress, Dialog } from '@mui/material';
import CloseButton from './CloseButton';

const DialogLoadingState = ({ onClose, loadingLabel, closeLabel }) => (
  <Dialog open onClose={onClose} PaperProps={{ 'aria-label': loadingLabel }}>
    <Box sx={{ position: 'relative', display: 'grid', placeItems: 'center', minWidth: 112, minHeight: 88, p: 3 }}>
      <CloseButton
        ariaLabel={closeLabel}
        onClick={onClose}
        sx={{ position: 'absolute', top: 2, right: 2 }}
      />
      <CircularProgress aria-label={loadingLabel} />
    </Box>
  </Dialog>
);

export default DialogLoadingState;
